export default {"src":"/_next/static/media/win.b904663f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};